'use strict';

/* jshint -W098 */
angular.module('mean.documents').controller('DocumentsController', ['$scope', '$sce', '$http', '$q', '$timeout', '$window', 'Upload', 'Projects', 'Global', 'Trades', 'contactService', 'ngDialog', 'Builders', 'builderService', 'documentConst', 'Users', 'userService', 'DocumentSevice', 'MeanUser', 'AWSUploadService', '$filter', 'toaster', '$anchorScroll', '$location',
  function ($scope, $sce, $http, $q, $timeout, $window, Upload, Projects, Global, Trades, contactService, ngDialog, Builders, builderService, documentConst, Users, userService, DocumentSevice, MeanUser, AWSUploadService, $filter, toaster, $anchorScroll, $location) {

    $scope.global = Global;
    $scope.package = { name: 'documents' };
    $scope.user = MeanUser.user;
    $scope.mainAccountId = null;
    $scope.seldocumentId = null;
    $scope.selCurrentNode = null;
    $scope.selCurrentDoc = null;
    $scope.selCurrentPrefix = null;
    $scope.selMainAccountId = null;
    $scope.selectedFile = null;
    $scope.chatInput = { data: '' };
    $scope.moveTargetId = null;
    $scope.moveTargetPrefix = null;
    $scope.tradeCode = null;
    $scope.isBuilder = false;
    $scope.newNodeData = null;
    $scope.uploadState = false;
    $scope.allSelected = false;
    $scope.builder = null;
    $scope.companyName = null;
    $scope.companySetup = [];
    $scope.projectSetup = [];
    $scope.bidsSetup = [];
    $scope.companyDocument = [];
    $scope.documentSetup = [];
    $scope.uploadedData = [];
    $scope.builders = [];
    $scope.isDocumentAdmin = false;
    $scope.isTrustedurl = false;
    $scope.rootPrefix = $scope.user.username.substring(0, 5) + '0000';

    $scope.activeTab = null;
    $scope.chatImageLoding = false;
    $scope.isBidTitledFolder = false;

    $scope.is_foreman = false;
    $scope.is_manager = false;
    $scope.foreman_projects = [];
    $scope.manager_projects = [];

    $scope.dropdownSettings = {
      scrollableHeight: '200px',
      scrollable: true,
      enableSearch: false,
      idProperty: '_id',
      smartButtonMaxItems: 3,
      smartButtonTextConverter: function (itemText, originalItem) { return itemText; }
    };

    $scope.filesMove = {
      header: 'Destination Folder',
      companyDocument: [],
      documentSetup: []
    }

    $scope.roleOptionData = angular.copy(documentConst.roleOptions);

    $scope.onInit = function () {

      $scope.user.roles.forEach(function (role) {
        if (role === 'foreman') {
          $scope.is_foreman = true;
        }
        if (role === 'tm') {
          $scope.is_manager = true;
        }
      });

      $scope.activeTab = 'Documents';

      if ($scope.user.roles.indexOf('tm_admin') !== -1
        || $scope.user.roles.indexOf('builder_admin') !== -1) {
        $scope.isDocumentAdmin = true;
      } else {
        $scope.isDocumentAdmin = false;
      }

      userService.getMainAccountId($scope.user.username)
        .then(function (id) {
          $scope.mainAccountId = id;
          $scope.tradeCode = userService.getTradeCode($scope.user.username);
          $scope.isBuilder = builderService.isBuilder($scope.user.username);

          if ($scope.isBuilder) {
            Builders.query({ 'builder': $scope.user._id }, function (builders) {
              if (builders.length) {
                $scope.builders = builders;
                $scope.builder = builders[0];
                $scope.companyName = $scope.builder.name;
                $scope.getDocumentData('document');
              }
            });
          } else {
            contactService.getMyContacts($scope.mainAccountId).then(function (contacts) {
              $scope.builders = [];

              Trades.query({ 'main_account_id': $scope.mainAccountId }, function (trades) {
                if (trades.length !== 1) {
                  toaster.pop('error', 'Trade', 'There is a problem getting the trade from the database');
                  return;
                }
                $scope.companyName = trades[0].main_account_id.name;
                $scope.builders.push(trades[0]);
                $scope.builder = { name: trades[0].name, builderId: trades[0]._id };

                if (contacts.builders.length) {
                  var isDone = false;
                  contacts.builders.forEach(function (builder, indexNo) {
                    Builders.query({ 'builder': builder._id }, function (builders) {
                      if (builders.length === 0) return;
                      $scope.builders.push(builders[0]);
                      if (indexNo === (contacts.builders.length - 1)) {
                        $scope.getDocumentData('document');
                      }
                    });
                  });
                } else {
                  $scope.getDocumentData('document');
                }
              });
            });
          }

          if ($scope.is_foreman) {
            Projects.query({
              'type': 'findForemanProjectNames',
              'company_code': $scope.user.contractor_code,
              'trade_code': $scope.tradeCode,
              'complete': false,
              'foreman': $scope.user.username
            }, function (projects) {

              $scope.foreman_projects = projects;
            });
          }
          if($scope.is_manager) {
            Projects.query({
              'type': 'findManagerProjects',
              'company_code': $scope.user.contractor_code,
              'trade_code': $scope.tradeCode,
              'complete': false,
              'manager': $scope.user.username }, function(projects) {
              if(projects.length === 0) return;
              $scope.manager_projects = projects;
          });
          }
          $scope.getDocumentData('company');
        });
    }

    $scope.showAddButton = function (node) {
      var isShow = true;
      var disbleTypes = ['other'];
      if (disbleTypes.indexOf(node.subType) !== -1
        || Number(node.depthsPos) === 5) {
        isShow = false;
      }
      return isShow;
    }

    $scope.getDocumentData = function (queryType) {

      // filter other builder main account id
      var otherBuilder = [];
      $scope.builders.forEach(function (item) {
        if (item.trade && item.main_account_id
          && item.main_account_id._id && $scope.mainAccountId != item.main_account_id._id) {
          otherBuilder.push(item.main_account_id._id);
        } else if (item.builder && item.builder._id
          && item.builder._id != $scope.mainAccountId) {
          otherBuilder.push(item.builder._id);
        }
      });
      DocumentSevice.query({
        type: 'defaultDocument', nodeType: queryType,
        isBuilder: $scope.isBuilder, builder: $scope.builder,
        otherBuilder: otherBuilder,
        company: $scope.companyName,
        userRole: $scope.user.roles[0],
        rootPrefix: $scope.rootPrefix,
        mainAccountId: $scope.mainAccountId
      }, function (result) {
        var sortedResult = _.sortBy(result, function (i) { return i.title; });
        $scope.buildTreesSetup(sortedResult, queryType);
      });
    }

    $scope.checkPermission = function (document) {
      var hasPermission = false;

      if ($scope.is_foreman && document.nodeType === 'document'
      && (document.subType === 'project' || document.subType === 'phase') && !$scope.isPublicFolder(document.subType)) {
        var filtered = $scope.foreman_projects.filter(function (item) {
          return item._id === document.projectId;
        });
        if (filtered.length && document.accGroup.indexOf($scope.user.roles[0]) !== -1) {
          hasPermission = true;
        }
      } else if ($scope.is_manager && document.nodeType === 'document'
      && (document.subType === 'project' || document.subType === 'phase') && !$scope.isPublicFolder(document.subType)) {
        var filtered1 = $scope.manager_projects.filter(function (item) {
          return item._id === document.projectId;
        });
        if (filtered1.length && document.accGroup.indexOf($scope.user.roles[0]) !== -1) { hasPermission = true; }
      } else {
        if ($scope.user.roles[0] === 'tm_admin' || $scope.user.roles[0] === 'builder_admin' || $scope.user.roles[0] === 'admin') {
          hasPermission = true;
        } else if (document.accGroup.indexOf($scope.user.roles[0]) !== -1) {
          hasPermission = true;
        }
      }

      return hasPermission;
    }

    $scope.isPublicFolder = function (subType) {
      var hasPermission = false;
      if(subType === 'curBids' || subType === 'bidBuilder' || subType === 'bidCompany'
      || subType === 'curProject' || subType === 'projectBuilder' || subType === 'projectCompany'
      || subType === 'shared' ) {
        hasPermission = true;
      }
      return hasPermission;
    }

    $scope.checkForemanAcc = function (document) {
      var hasPermission = false;
      if ($scope.is_foreman && document.nodeType === 'document' 
      && (document.subType === 'project' || document.subType === 'phase') && !$scope.isPublicFolder(document.subType)) {
        var filtered = $scope.foreman_projects.filter(function (item) {
          return item._id === document.projectId;
        });
        if (filtered.length) { hasPermission = true; }
      } else if ($scope.is_manager && document.nodeType === 'document' 
      && (document.subType === 'project' || document.subType === 'phase') && !$scope.isPublicFolder(document.subType)) {
        var filtered1 = $scope.manager_projects.filter(function (item) {
          return item._id === document.projectId;
        });
        if (filtered1.length) { hasPermission = true; }
      } else {
        if (document.accGroup.indexOf($scope.user.roles[0]) !== -1) {
          hasPermission = true;
        } else if (document.nodeType === 'company') {
          hasPermission = true;
        }
      }
      return hasPermission;
    }

    $scope.setCurrentNode = function ($event, selNode) {
      $event.stopPropagation();
      if ($scope.checkPermission(selNode.$modelValue)) {
        $scope.selCurrentNode = selNode.$modelValue._id;
        $scope.selCurrentDoc = selNode.$modelValue;
        $scope.selCurrentPrefix = selNode.$modelValue.pathPrefix;
        $scope.selMainAccountId = selNode.$modelValue.mainAccountId;
        $scope.getNodeData();
      } else {
        toaster.pop('error', 'Permission Denied', 'You do not have permission to view file.');
      }
    }

    $scope.setTargetNode = function ($event, selNode) {
      $event.stopPropagation();
      if ($scope.checkPermission(selNode.$modelValue)) {

        if (selNode.$modelValue.nodeType === 'document'
          && selNode.$modelValue.subType === 'bid' && selNode.$modelValue.depthsPos === 0) {
          toaster.pop('error', 'Move Folder Error', 'You could not move file into Bid Name folder.');
          return;
        }
        $scope.moveTargetId = selNode.$modelValue._id;
        $scope.moveTargetPrefix = selNode.$modelValue.pathPrefix;
      } else {
        toaster.pop('error', 'Permission Denied', 'You could not move file into this folder.');
      }
    }


    $scope.moveFilePopup = function () {

      if ($scope.user.roles[0] !== 'tm_admin' && $scope.user.roles[0] !== 'builder_admin') {
        toaster.pop('error', 'Move Error', 'You do not have permission to move file.');
        return;
      }

      var selectedIds = [];
      var otherTradeFiles = [];

      for (var i = 0; i < $scope.uploadedData.length; i++) {
        if ($scope.uploadedData[i].select) {
          selectedIds.push($scope.uploadedData[i]._id);
          if ($scope.uploadedData[i].mainAccountId.toString() !== $scope.mainAccountId.toString()) {
            otherTradeFiles.push($scope.uploadedData[i]);
          }
        }
      }

      if (otherTradeFiles.length) {
        toaster.pop('error', 'Move Error', 'You can\' move ' + otherTradeFiles[0].fileName + ' file');
        return;
      }

      if (selectedIds.length) {
        $scope.filesMove = {
          header: 'Destination Folder',
          companyDocument: angular.copy($scope.companyDocument),
          documentSetup: angular.copy($scope.documentSetup)
        }
        ngDialog.openConfirm({
          template: 'documents/views/move-node.html',
          scope: $scope,
          className: 'ngdialog-theme-default newNode'
        }).then(function () {
          if ($scope.moveTargetId) {
            $scope.moveFiles(selectedIds);
          } else {
            $scope.moveTargetId = null;
            $scope.moveTargetPrefix = null;
          }
        }, function (value) {
          $scope.moveTargetId = null;
          $scope.moveTargetPrefix = null;
        });
      } else {
        toaster.pop('error', 'Select File', 'No file selected for move.');
      }
    }

    $scope.moveFiles = function (selectedIds) {
      if ($scope.seldocumentId !== $scope.moveTargetId) {
        AWSUploadService.query({
          type: 'moveAction',
          fileIds: selectedIds,
          pathPrefix: $scope.selCurrentPrefix,
          targetPrefix: $scope.moveTargetPrefix,
          targetId: $scope.moveTargetId
        }, function (result) {
          $scope.moveTargetId = null;
          $scope.moveTargetPrefix = null;
          toaster.pop('success', 'File Moved', 'File moved successfully.');
          $scope.getNodeData();
        });
      } else {
        toaster.pop('error', 'Error', 'Select different directory.');
      }
    }

    $scope.removeFile = function () {

      if ($scope.user.roles[0] !== 'tm_admin' && $scope.user.roles[0] !== 'builder_admin') {
        toaster.pop('error', 'Delete Error', 'You do not have permission to delete file.');
        return;
      }

      var selectedIds = [];
      var otherTradeFiles = [];

      for (var i = 0; i < $scope.uploadedData.length; i++) {
        if ($scope.uploadedData[i].select) {
          selectedIds.push($scope.uploadedData[i]._id);
          if ($scope.uploadedData[i].mainAccountId.toString() !== $scope.mainAccountId.toString()) {
            otherTradeFiles.push($scope.uploadedData[i]);
          }
        }
      }

      if (otherTradeFiles.length) {
        toaster.pop('error', 'Delete Error', 'You can\' delete ' + otherTradeFiles[0].fileName + ' file');
        return;
      }

      if (selectedIds.length) {
        AWSUploadService.query({
          type: 'deleteAction',
          deletedIds: selectedIds
        }, function (result) {
          toaster.pop('success', 'Files Deleted', 'Files successfully deleted.');
          $scope.getNodeData();
        });
      } else {
        toaster.pop('error', 'Select File', 'No file selected for delete.');
      }
    }

    $scope.upload = function (files) {
      if (files && files.length) {
        if ($scope.selCurrentDoc.nodeType === 'document'
          && $scope.selCurrentDoc.subType === 'bid' && $scope.selCurrentDoc.depthsPos === 0) {
          toaster.pop('error', 'Upload Error', 'You could not upload file to Bid Name folder.');
          return;
        }

        for (var i = 0; i < files.length; i++) {
          $scope.uploadState = true;
          Upload.upload({
            url: '/api/awsUploads', data: {
              'file': files[i],
              'documentId': $scope.selCurrentNode,
              'pathPrefix': $scope.selCurrentPrefix,
              'mainAccountId': $scope.selMainAccountId,
              'uploadedBy': $scope.user.username
            }
          }).then(function (resp) {
            $scope.uploadState = false;
            $scope.getNodeData();
          });
        }
      }
    };

    $scope.getNodeData = function () {
      AWSUploadService.query({
        documentId: $scope.selCurrentNode,
        mainAccountId: $scope.selMainAccountId,
        isUploaded: true
      }, function (result) {
        $scope.allSelected = false;
        $scope.uploadedData = result;
      });
    }

    $scope.getSetupData = function (queryType) {
      DocumentSevice.query({
        type: 'defaultCheck',
        nodeType: queryType,
        isBuilder: $scope.isBuilder,
        userRole: $scope.user.roles[0],
        rootPrefix: $scope.rootPrefix,
        mainAccountId: $scope.mainAccountId
      }, function (result) {
        var sortedResult = _.sortBy(result, function (i) { return i.title; })
        $scope.buildTreesSetup(sortedResult, queryType);
      });
    }

    $scope.buildTreesSetup = function (data, queryType) {
      // filter parent 
      var rootData = data.filter(function (items) { return !items.parentId; });
      // group child array
      var childItems = data.filter(function (items) { return items.parentId; });
      for (var i = 0; i < childItems.length; i++) {
        if (!childItems[i].nodes.length) {
          childItems[i].nodes = childItems.filter(function (item) { return childItems[i]._id == item.parentId });
        }
      }

      var groupedItems = _.groupBy(childItems, 'parentId');

      for (var i = 0; i < rootData.length; i++) {

        for (var parentId in groupedItems) {
          if (groupedItems.hasOwnProperty(parentId)) {
            if (rootData[i]._id === parentId) {
              rootData[i].nodes = groupedItems[parentId];
            }
          }
        }
      }
      (queryType === 'setup') ? ($scope.companySetup = [])
        : (queryType === 'psetup') ? ($scope.projectSetup = [])
          : (queryType === 'document') ? ($scope.documentSetup = [])
            : (queryType === 'company') ? ($scope.companyDocument = [])
              : ($scope.bidsSetup = []);

      (queryType === 'setup') ? ($scope.companySetup = angular.copy(rootData))
        : (queryType === 'psetup') ? ($scope.projectSetup = angular.copy(rootData))
          : (queryType === 'document') ? ($scope.documentSetup = angular.copy(rootData))
            : (queryType === 'company') ? ($scope.companyDocument = angular.copy(rootData))
              : ($scope.bidsSetup = angular.copy(rootData));
    }

    $scope.remove = function (scope) {
      scope.remove();
    };

    $scope.editRole = function (node) {
      node.rEdit = !node.rEdit;
      var copyObj = angular.copy(node);
      copyObj.editType = 'role';
      if (!node.rEdit) {
        copyObj.$update();
      }
    }


    $scope.roleChanged = {
      onSelectionChanged: function () {
        console.log('role changed');
      }
    }

    $scope.onSelect = function (activeTab) {
      $scope.activeTab = activeTab;
      if (activeTab === 'Documents') {
        $scope.getDocumentData('company');
        $scope.getDocumentData('document');
      } else {
        if ($scope.user.roles.indexOf('tm_admin') !== -1
          || $scope.user.roles.indexOf('builder_admin') !== -1) {
          $scope.getSetupData('setup');
          $scope.getSetupData('psetup');
          $scope.getSetupData('bsetup');
        } else {
          $scope.getSetupData('company');
        }
      }
    }

    $scope.toggleNode = function (scope) {
      if ($scope.checkPermission(scope.$modelValue)) {
        scope.toggle();
      } else {
        toaster.pop('error', 'Permission Denied', 'You do not have permission.');
      }
    };

    $scope.moveLastToTheBeginning = function () {
      var a = $scope.data.pop();
      $scope.data.splice(0, 0, a);
    };

    $scope.newSubItem = function (scope) {

      var nodeData = scope === null ? $scope.selCurrentDoc : scope.$modelValue || scope;

      $scope.newNodeData = {
        header: 'Add sub folder',
        title: ''
      }

      if ((Number(nodeData.depthsPos) + 1) > 4) {
        toaster.pop('error', 'Error', 'You can not add sub folder.');
        return;
      }

      ngDialog.openConfirm({
        template: 'documents/views/new-node.html',
        scope: $scope,
        className: 'ngdialog-theme-default newNode'
      }).then(function (value) {
        var regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
        if (regex.test(value.title)) {
          toaster.pop('error', 'Error', 'You can\'t use special symbol in folder name.');
          return;
        }
        if (value.title) {
          var folderTitle = angular.copy(value.title);

          // check for duplicate folder name
          var duplicateTitle = [];
          duplicateTitle = nodeData.nodes.filter(function (item) {
            return (item.title.toLowerCase() === folderTitle.toLowerCase().trim());
          });
          if (duplicateTitle.length) {
            toaster.pop('error', 'Duplicate Folder', 'You can\'t create duplicate folder.');
            return;
          }

          var subTypeNode = nodeData.subType === 'company' ? 'employee'
            : nodeData.subType === 'employee' ? 'empnumber'
              : nodeData.subType === 'empnumber' ? 'empnumber'
                : nodeData.subType === 'shared' ? 'shared'
                  : nodeData.subType === 'project' ? 'information'
                    : nodeData.subType === 'information' ? 'information'
                      : nodeData.subType === 'phase' ? 'billing'
                        : nodeData.subType === 'billing' ? 'billing'
                          : nodeData.subType === 'tasknote' ? 'tasknote'
                            : nodeData.subType === 'orders' ? 'orders'
                              : nodeData.subType === 'options' ? 'options'
                                : nodeData.subType === 'curBids' ? 'custom'
                                  : nodeData.subType === 'bidBuilder' ? 'custom'
                                    : nodeData.subType === 'bidCompany' ? 'custom'
                                      : nodeData.subType === 'curProject' ? 'custom'
                                        : nodeData.subType === 'projectBuilder' ? 'custom'
                                          : nodeData.subType === 'projectCompany' ? 'custom'
                                            : nodeData.subType === 'extras' ? 'extras' : nodeData.subType;
          var rootPrefix = nodeData.pathPrefix + '/' + folderTitle.replace(/\s/g, '-');

          var newDocObject = new DocumentSevice({
            mainAccountId: nodeData.mainAccountId,
            title: value.title,
            subType: subTypeNode,
            roles: nodeData.roles,
            accGroup: nodeData.accGroup,
            nodeType: nodeData.nodeType,
            depthsPos: (nodeData.depthsPos + 1),
            projectId: nodeData['projectId'],
            parentId: nodeData['_id'],
            pathPrefix: rootPrefix,
            isCustom: true
          });
          newDocObject.$save(function (newItem) {
            scope && scope.expand();
            nodeData.nodes.push(newItem);
            toaster.pop('success', 'Added', 'New Folder Added Successfully.');
          });
        }
        $scope.newNodeData = null
      }, function (value) {
        $scope.newNodeData = null;
      });
    };

    $scope.deleteFolder = function (node) {
      var nodeData = node ? node : $scope.selCurrentDoc;
      nodeData.$remove(function (res) {
        if (nodeData.nodeType === 'setup') {
          $scope.getSetupData('setup');
        } else if (nodeData.nodeType === 'psetup') {
          $scope.getSetupData('psetup');
        } else if (nodeData.nodeType === 'bsetup') {
          $scope.getSetupData('bsetup');
        } else if (nodeData.nodeType === 'company') {
          $scope.getSetupData('company');
        } else {
          $scope.getDocumentData('document');
        }
      });
    }

    $scope.editTitle = function (item) {
      if ((item.nodeType === 'bsetup' && (item.subType === 'bid' || item.subType === 'sub_bid'))
        || (item.nodeType === 'psetup' && (item.subType === 'phase' || item.depthsPos === 1))) {
        return;
      }
      item.editMode = true;
    };

    $scope.doneEditTitle = function (item) {
      if (!item.editMode) return;
      var regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
      if (regex.test(item.title)) {
        toaster.pop('error', 'Error', 'You can\'t use special symbol in folder name.');
        return;
      }
      var copyObj = angular.copy(item);
      copyObj.editType = 'title';
      copyObj.$update();
      item.editMode = false;
    };

    $scope.bytesToSize = function (bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes == 0) return '0 Byte';
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    }

    $scope.getFileName = function (filename) {
      return filename.split('.').slice(0, -1).join('.');
    }

    $scope.getClass = function (fileType) {
      var className = fileType.includes('pdf') ? 'pdf'
        : fileType.includes('image') ? 'image' : 'other';
      return className;
    }

    $scope.regenrateFile = function($event, awsDocs) {
      $event.stopPropagation();
      console.log('*^^^^^', awsDocs, $scope.selCurrentDoc);
      $http.post('/api/regenerateLotPdf', {
        pathPrefix: $scope.selCurrentDoc.pathPrefix,
        updateDocId: awsDocs._id,
        lot: awsDocs.lotNumber,
        phase: awsDocs.phaseNumber,
        project_id: $scope.selCurrentDoc.projectId
      }).success(function (data) {
        toaster.pop('success', 'Regenerated', 'PDF lot regenerated successfully.');
        $scope.getNodeData();
      }).error(function (error) {
        console.log('There was an error with the message', error);
      });
    }

    $scope.downloadFile = function (file) {
      if(!file.fileUrl) {
        toaster.pop('error', 'Download Error', 'Kindly regenerat your file by refresh button.');
        return;
      }
      $http.post('/api/getPreSignedUrl', { fileKey: file.fileUrl }).
        success(function (data) {
          if (file.fileTypes.includes('pdf') || file.fileTypes.includes('PDF')) {
            $window.open(data.tempUrl, '_system');
          } else if (file.fileTypes.includes('image')) {
            $window.open(data.tempUrl, '_system');
          } else {
            var a = document.createElement("a");
            a.href = data.tempUrl;
            a.click();
          }
        }).
        error(function (error) {
          console.log('There was an error with the message', error);
        });
    }

    $scope.selectedItem = function (item) {
      $scope.checkSelectedAll();
    }

    $scope.checkSelectedAll = function () {
      var isSelectedAll = true;
      for (var i = 0; i < $scope.uploadedData.length; i++) {
        if (!$scope.uploadedData[i].select) {
          isSelectedAll = false;
        }
      }
      $scope.allSelected = isSelectedAll;
    }

    $scope.selectAll = function (allSelected) {
      $scope.uploadedData = $scope.uploadedData.map(function (item) {
        if(!item.lotNumber){
          item.select = allSelected;
        }
        return item;
      });
    }

    $scope.openChatBox = function (fileDoc) {

      $scope.selectedFile = fileDoc;
      fileDoc.comments.forEach(function (item, index) {
        if (item.read.indexOf($scope.user.username) === -1) {
          fileDoc.comments[index].read.push($scope.user.username);
        }
      });
      // make read all comments
      var promisesDocs = [];
      fileDoc.comments.forEach(function(comItem) {
        if(comItem.type === 'link') {
          var deferred = $q.defer();
          $http.post('/api/getPreSignedUrl', { fileKey: comItem.text }).success(function (data) {
            comItem.text = data.tempUrl;
            deferred.resolve();
          });
          promisesDocs.push(deferred);
        }
      });
      if(promisesDocs.length) {
        $q.all(promisesDocs).then(function(done) {
          fileDoc.$update(function (doc) {
            $scope.chatInput = { data: '' };
            ngDialog.openConfirm({
              template: 'documents/views/chat-box.html',
              scope: $scope,
              className: 'ngdialog-theme-default chatNode'
            }).then(function () {
            }, function (value) {
              $scope.selectedFile = null;
              $scope.chatInput = { data: '' };
            });
          });
        });
      } else {
          fileDoc.$update(function (doc) {
            $scope.chatInput = { data: '' };
            ngDialog.openConfirm({
              template: 'documents/views/chat-box.html',
              scope: $scope,
              className: 'ngdialog-theme-default chatNode'
            }).then(function () {
            }, function (value) {
              $scope.selectedFile = null;
              $scope.chatInput = { data: '' };
            });
          });
      }
    }

    $scope.sendMessage = function (keyEvent) {
      !$scope.selectedFile.comments && ($scope.selectedFile.comments = []);
      $scope.selectedFile.comments.push({
        user: $scope.user.username,
        name: $scope.user.name,
        text: $scope.chatInput.data,
        type: 'text',
        read: [$scope.user.username],
      });
      $scope.selectedFile.$update(function (docs) {
        $scope.selectedFile = docs;
        $scope.chatInput = { data: '' };
        var newHash = 'anchor-' + docs.comments[docs.comments.length - 1]._id;
        if ($location.hash() !== newHash) {
          $location.hash('anchor=' + docs.comments[docs.comments.length - 1]._id);
        } else {
          $anchorScroll();
        }
      });
    }

    $scope.uploadChat = function (file) {
      if (file === null) return;
      $scope.chatImageLoding = true;
      $location.hash('chatLoading');
      $anchorScroll();
      Upload.upload({
        url: '/api/chatUpload', data: {
          'file': file,
          'documentId': $scope.selCurrentNode,
          'uploadedBy': $scope.user.username,
          'mainAccountId': $scope.mainAccountId,
          'pathPrefix': $scope.selCurrentPrefix
        },
      }).then(function (resp) {
        $scope.chatImageLoding = false;
        !$scope.selectedFile.comments && ($scope.selectedFile.comments = []);
        $scope.selectedFile.comments.push({
          user: $scope.user.username,
          text: resp.data.url,
          type: 'link',
          read: [$scope.user.username],
        });
        $scope.selectedFile.$update(function (docs) {
          $scope.selectedFile = docs;
          $scope.chatInput = { data: '' };
        });
        $scope.getNodeData();
      }, function (error) {
        $scope.chatImageLoding = false;
      });
    };

    $scope.openImag = function (url) {
      $http.post('/api/getPreSignedUrl', { fileKey: url }).
        success(function (data) {
          var a = document.createElement("a");
          a.href = data.tempUrl;
          a.target = '_blank';
          a.click();
        }).
        error(function (error) {
          console.log('There was an error with the message', error);
        });
    }

    $scope.getSignedUrl = function (url) {
      var singedUrl = null;
      $http.post('/api/getPreSignedUrl', { fileKey: url }).
        success(function (data) {
          singedUrl = data.tempUrl;
        }).
        error(function (error) {
          console.log('There was an error with the message', error);
        });
      return singedUrl;
    }

    $scope.getCommentCount = function (comments) {
      var totalCount = 0;
      totalCount = (comments.length > 0 && comments.length < 10) ? ('0' + comments.length)
        : comments.length === 10 ? '10'
          : comments.length === 0 ? '0' : '10+';
      return totalCount;
    }

    $scope.hasUnreadComments = function (comments) {
      var unreadStatus = false;
      comments.forEach(function (item) {
        if (item.read.indexOf($scope.user.username) === -1) {
          unreadStatus = true;
        }
      });
      return unreadStatus;
    }

    $scope.getTextLink = function (text) {
      var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      var htmlText = text.replace(urlRegex, function (url) {
        var encodeData = url.split('/');
        encodeData[encodeData.length - 1] = encodeURIComponent(encodeData[encodeData.length - 1]);
        var fileUrls = encodeData.join('/');
        return '<a class="image-stype" href="' + fileUrls + '" target="_blank" ><img src="' + fileUrls + '" /> </a>';
      });
      return $sce.trustAsHtml(htmlText);
    }

  }]);



// WEBPACK FOOTER //
// ./packages/custom/documents/public/controllers/documents.js